<template>
  <div class="modal-content">
    <div class="modal-content__wrapper">
      <h3 class="modal-title">{{ title }}</h3>
      <p v-if="text" class="modal-text">{{ text }}</p>

      <dl class="modal-fields">
        <div
          v-for="field in modalData"
          :key="field.name"
          class="form-group"
        >
          <dt class="form-label">{{ field.title }}:&nbsp;</dt>
          <dd
            v-if="field.name === 'clientPhoneNumber'"
            class="modal-field-value"
          >
            <a :href="`tel:${phoneHref(getFieldValue(field))}`">{{ getFieldValue(field) }}</a>
          </dd>

          <dd
            v-else
            class="modal-field-value"
          >{{ getFieldValue(field) }}</dd>
        </div>

        <div
          v-if="name === 'repair'"
          class="form-group"
        >
          <dt class="form-label">Всего затрачено:&nbsp;</dt>
          <dd class="modal-field-value">{{ expendedAmount }}</dd>
        </div>
      </dl>

      <repair-cash-operations
        v-if="name === 'repair'"
        :repair-id="data.id"
        :cash-operations="data.cashOperations"
      />
    </div>

    <div class="modal-actions">
      <button
        type="button"
        class="modal-button modal-button--cancel"
        @click="closeModal(null)"
      >
        {{ textCancelBtn }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { priceToFormat } from '@/helper'

import RepairCashOperations from '@/components/modals/infoBase/components/repairCashOperations'

export default {
  name: 'InfoBase',
  props: {
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    textCancelBtn: {
      type: String,
      default: 'Закрыть'
    },
    onClose: {
      type: Function,
      default: null
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    RepairCashOperations
  },
  data () {
    return {
      modalData: []
    }
  },
  computed: {
    ...mapGetters('settings', ['getDefaultValues']),
    expendedAmount () {
      return priceToFormat(this.data?.cashOperations?.reduce((acc, { amount }) => acc += Number(amount), 0) || 0)
    }
  },
  mounted () {
    this.seedForm()
  },
  beforeDestroy () {
    if (typeof this.onClose === 'function') {
      this.onClose()
    }
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    ...mapActions('settings', ['loadModalData']),
    priceToFormat,
    getFieldValue (field) {
      return this.data?.[field.name] || '—'
    },
    phoneHref (value) {
      return String(value).replace(/[^+\d]/g, '')
    },
    async seedForm () {
      this.$bus.emit('start-loader')

      const { data, error } = await this.loadModalData({
        name: this.name,
        type: this.type
      })

      if (error) {
        this.$notify({
          type: 'error',
          title: 'Ошибка при загрузке данных!',
          text: 'Произошла ошибка при загрузке полей для модального окна!',
          clean: false,
          duration: 3000
        })

        this.$bus.emit('stop-loader')

        await this.closeModal(null)
      }

      this.modalData = data

      this.$bus.emit('stop-loader')
    }
  }
}
</script>

<style lang="scss" src="./style.scss" scoped />
